import callApi from '../../util/apiCaller';
// Export Constants
export const ADD_OUTCOME = 'ADD_OUTCOME';
export const ADD_OUTCOME_FORECAST = 'ADD_OUTCOME_FORECAST';

export function fetchOpportunities(criteria) {
  return (dispatch) => {
    const empty = {
      opportunities: [],
      owners: {},
    };
    dispatch({
      type: ADD_OUTCOME, ...empty, status: 'loading', errors: null,
    });
    const included = [
      'owners',
      'lineItems',
      'opportunityCompetitors',
    ];
    const { team } = criteria;
    const teamId = team && team._id ? `&teamId=${team._id}` : '';
    const p = callApi(`search/performance?include=${included.join(',')}${teamId}`, 'POST', criteria);
    p.then(
      results => dispatch({
        type: ADD_OUTCOME, ...results, status: 'loaded', errors: null,
      }),
      errors => dispatch({
        type: ADD_OUTCOME, ...empty, status: 'error', errors,
      }),
    );
    return p;
  };
}

export function reset() {
  return (dispatch) => {
    dispatch({
      type: ADD_OUTCOME, owners: {}, opportunities: [], status: null, errors: null,
    });
    return Promise.resolve();
  };
}

export function fetchForecast(criteria, forecastMappings, key = 'forecast') {
  const newCriteria = {
    ...criteria,
    query: {
      type: 'groupAND',
      values: [
        forecastMappings,
        criteria.query,
      ],
    },
  };

  return (dispatch) => {
    dispatch({
      type: ADD_OUTCOME_FORECAST, status: 'loading', errors: null, key,
    });
    const { team } = criteria;
    const teamId = team && team._id ? `?teamId=${team._id}` : '';
    delete newCriteria.team;
    const p = callApi(`search/performance/forecast${teamId}`, 'POST', newCriteria);
    p.then(
      results => dispatch({
        type: ADD_OUTCOME_FORECAST, ...results, status: 'loaded', key, errors: null,
      }),
      errors => dispatch({
        type: ADD_OUTCOME_FORECAST, status: 'error', key, errors,
      }),
    );
    return p;
  };
}
